import React, { useState } from "react";
import MembershipHead from "../../component/MembershipHead/MembershipHead";
import { Button, Col, Container, Form, Modal, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

const Membership = () => {
  const [show, setShow] = useState(false);
  const navigate = useNavigate();

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  return (
    <div>
      <MembershipHead />
      <section id="service-details" className="service-details">
        <div className="container" data-aos="fade-up" data-aos-delay="100">
          <div className="row gy-4 mobcol">
            <div className="col-lg-12">
              <h3>Membership</h3>
              <ul>
                <p>
                  Membership is open to all individuals and organizations who
                  are working on solutions to advance the cause of SDGs. Our
                  members include profit-based and nonprofit-based social
                  enterprises, civil society, businesses, fund supporters,
                  academics, intermediaries, media organizations, government
                  departments and technical assistance providers. We have three
                  levels of membership as indicated below:
                </p>
                <li style={{ paddingLeft: "19px" }}>
                  <span className="bolder">Personal level</span>
                </li>
                <p style={{ paddingLeft: "19px" }}>
                  You can grow deep personal connections with changemakers
                  worldwide as you engage in collaborative work to help shift
                  the dominant culture and uphold our core values. Support each
                  other’s work and wellbeing in a collaborative and supportive
                  space.
                </p>
                <li style={{ paddingLeft: "19px" }}>
                  <span className="bolder">Organizational level</span>
                </li>
                <p style={{ paddingLeft: "19px" }}>
                  Engage with a like-minded community of people and
                  organizations who work together to achieve lasting social
                  change in the world. Create and collaborate on innovative and
                  impactful projects to help advance the Sustainable Development
                  Goals (SDGs) by 2030.
                </p>
                <li style={{ paddingLeft: "19px" }}>
                  <span className="bolder">System Level</span>
                </li>
                <p style={{ paddingLeft: "19px" }}>
                  Join a global movement of people and organizations that engage
                  in collective action towards achieving the SDGs by 2030.
                  Enterprising for value creation to influence social,
                  government and economic systems at all levels, shifting the
                  dominant culture, and influencing the practices of
                  communities, governments, and corporations.
                </p>
                <li style={{ paddingLeft: "19px" }}>
                  <span className="bolder">
                    Membership application guidelines
                  </span>
                </li>
                <p style={{ paddingLeft: "19px" }}>
                  The four main considerations when approving an application for
                  membership include the applicant’s:
                  <li style={{ paddingLeft: "19px" }}>
                    <span className="bolder">
                      Commitment to creating lasting solutions to achieve the
                      SDGs;
                    </span>
                  </li>
                  <p style={{ paddingLeft: "19px" }}>
                    Working towards adopting systems change approaches (i.e.
                    addressing root causes of problems); Application of or
                    commitment to using collaborative approaches in the SDG
                    pursuit
                  </p>
                  <li style={{ paddingLeft: "19px" }}>
                    <span className="bolder">
                      Commitment to diversity, equity and inclusion.
                    </span>
                  </li>
                  <p style={{ paddingLeft: "19px" }}>
                    The four approval criteria encompass:
                  </p>
                  <li style={{ paddingLeft: "28px" }}>
                    <i className="bi bi-check-circle"></i>{" "}
                    <span className="bolder">Mission alignment</span>
                  </li>
                  <p style={{ paddingLeft: "28px" }}>
                    The organisation (or individual) is actively involved in
                    practices or projects that align with the movement’s goal of
                    attaining the SDGs.
                  </p>
                  <li style={{ paddingLeft: "28px" }}>
                    <i className="bi bi-check-circle"></i>{" "}
                    <span className="bolder">
                      Social entrepreneurship and related expertise
                    </span>
                  </li>
                  <p style={{ paddingLeft: "28px" }}>
                    Applicants must have some knowledge and skills in the field
                    of social entrepreneurship. Understanding of social change
                    and/or the skills that drive or support social change
                    processes will be preferable.
                  </p>
                  <li style={{ paddingLeft: "28px" }}>
                    <i className="bi bi-check-circle"></i>{" "}
                    <span className="bolder">
                      Impact experience / Impact growth potential
                    </span>
                  </li>
                  <p style={{ paddingLeft: "28px" }}>
                    An organisation (or individual) has a track record of
                    impacting change in communities, organisations, industries
                    or sectors. Alternatively, if the desired outcomes have not
                    yet been achieved, a readiness to develop effective systems
                    change impacts will be considered.
                  </p>
                  <li style={{ paddingLeft: "28px" }}>
                    <i className="bi bi-check-circle"></i>{" "}
                    <span className="bolder">Relevant networks</span>
                  </li>
                  <p style={{ paddingLeft: "28px" }}>
                    An organisation (or individual) is engaging actively with
                    social change networks or collaborations. These networks
                    refer to underserved communities, professionals, experts or
                    impact investors who are working in the social change field
                  </p>
                </p>
              </ul>
              <div style={{ width: "20%" }}>
                Kindly fill the form to Join us
                <Button
                  className="battun"
                  onClick={() => {
                    navigate("/login");
                  }}
                >
                  Login
                </Button>
                <Button
                  className="battun"
                  onClick={() => {
                    setShow(true);
                  }}
                >
                  Join Now
                </Button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Modal  */}
      <Modal show={show} onHide={handleClose} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Membership Enrollment</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Container>
            <Form>
              <Form.Group
                className="mb-3"
                controlId="exampleForm.ControlInput1"
              >
                <Form.Label>Membership Type</Form.Label>
                <Form.Select aria-label="Default select example">
                  <option>Select Item</option>
                  <option value="individual">Individual</option>
                  <option value="organization">Organization</option>
                </Form.Select>
              </Form.Group>
              <Form.Group
                className="mb-3"
                controlId="exampleForm.ControlInput1"
              >
                <Form.Label>
                  Select the sub group that best describes you
                </Form.Label>
                <Form.Select aria-label="Default select example">
                  <option>Select Item</option>
                  <option value="profit">Profit-Based</option>
                  <option value="non-profit">Non-Profit-Based</option>
                  <option value="hybrid">Hybrid</option>
                </Form.Select>
              </Form.Group>
              <Row>
                <Col xs={12} md={6}>
                  <Form.Group
                    className="mb-3"
                    controlId="exampleForm.ControlTextarea1"
                  >
                    <Form.Label>First Name</Form.Label>
                    <Form.Control type="text" />
                  </Form.Group>
                </Col>
                <Col xs={12} md={6}>
                  <Form.Group
                    className="mb-3"
                    controlId="exampleForm.ControlTextarea1"
                  >
                    <Form.Label>Last Name</Form.Label>
                    <Form.Control type="text" />
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col xs={12} md={6}>
                  <Form.Group
                    className="mb-3"
                    controlId="exampleForm.ControlTextarea1"
                  >
                    <Form.Label>Gender</Form.Label>
                    <Form.Control type="text" />
                  </Form.Group>
                </Col>
                <Col xs={12} md={6}>
                  <Form.Group
                    className="mb-3"
                    controlId="exampleForm.ControlTextarea1"
                  >
                    <Form.Label>Date of Birth</Form.Label>
                    <Form.Control type="date" />
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col xs={12} md={6}>
                  <Form.Group
                    className="mb-3"
                    controlId="exampleForm.ControlTextarea1"
                  >
                    <Form.Label>Country of Location</Form.Label>
                    <Form.Control type="text" />
                  </Form.Group>
                </Col>
                <Col xs={12} md={6}>
                  <Form.Group
                    className="mb-3"
                    controlId="exampleForm.ControlTextarea1"
                  >
                    <Form.Label>City of Location</Form.Label>
                    <Form.Control type="text" />
                  </Form.Group>
                </Col>
              </Row>
              <Form.Group
                className="mb-3"
                controlId="exampleForm.ControlTextarea1"
              >
                <Form.Label>Email</Form.Label>
                <Form.Control type="email" />
              </Form.Group>

              <Form.Group
                className="mb-3"
                controlId="exampleForm.ControlInput1"
              >
                <Form.Label>
                  Do you have authority to represent your organization{" "}
                </Form.Label>
                <Form.Select aria-label="Default select example">
                  <option>Select Item</option>
                  <option value="yes">Yes</option>
                  <option value="no">No</option>
                </Form.Select>
              </Form.Group>

              <Form.Group
                className="mb-3"
                controlId="exampleForm.ControlTextarea1"
              >
                <Form.Label>Job Title or Position</Form.Label>
                <Form.Control type="text" />
              </Form.Group>
            </Form>
          </Container>
        </Modal.Body>
        <Modal.Footer>
          <Button className="battoun" onClick={handleClose}>
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal>
      {/* Modal  */}
    </div>
  );
};

export default Membership;
